import React, { useEffect, useState } from 'react'
import styles from '@/components/ui/loaders/CWGridLoader.module.css'

const CWGridLoader = ({ loading }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isAnimatingOut, setIsAnimatingOut] = useState(false)
  const [shouldRender, setShouldRender] = useState(false)
  const [dimensions, setDimensions] = useState({ width: 20, height: 10 }) // Default dimensions

  useEffect(() => {
    const updateDimensions = () => {
      const width = window.innerWidth
      if (width <= 480) {
        setDimensions({ width: 10, height: 20 })
      } else if (width <= 768) {
        setDimensions({ width: 10, height: 20 })
      } else {
        setDimensions({ width: 20, height: 10 })
      }
    }

    updateDimensions() // Initial check
    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const squares = Array.from({ length: dimensions.width * dimensions.height })

  useEffect(() => {
    if (loading) {
      setShouldRender(true)
      setTimeout(() => {
        setIsOpen(true)
        setIsAnimatingOut(false)
      }, 10) // Small timeout to ensure initial CSS applies
    } else {
      setIsAnimatingOut(true)
      setTimeout(() => {
        setIsOpen(false)
        setShouldRender(false)
      }, 1000) // Duration of the closing animation
    }
  }, [loading])

  useEffect(() => {
    const bodyClasses = document.body.classList
    if (isOpen) {
      bodyClasses.add('modalOpen')
    } else {
      bodyClasses.remove('modalOpen')
    }
    return () => {
      bodyClasses.remove('modalOpen')
    }
  }, [isOpen])

  if (!shouldRender) return null

  return (
    <div
      className={`${styles.modal} ${isAnimatingOut ? styles.animateOut : styles.animateIn}`}
      style={{ display: isOpen || isAnimatingOut ? 'flex' : 'none' }}
    >
      <div className={`${styles.loadingText} ${isAnimatingOut ? styles.loadingTextOut : styles.loadingTextIn}`}>
        SEARCHING
      </div>
      <div className={`${styles.loader} ${isAnimatingOut ? styles.loaderOut : styles.loaderIn}`}>
        {squares.map((_, index) => {
          const delay = Math.random() * 2 // random delay between 0 and 2 seconds
          const duration = 0.5 + Math.random() * 2 // random duration between 0.5 and 2.5 seconds
          const style = {
            animationDelay: `${delay}s`,
            animationDuration: `${duration}s`,
          }
          return <div key={index} className={styles.square} style={style} />
        })}
      </div>
    </div>
  )
}

export default CWGridLoader
